import "./CoreMessage.css"
import heroimage from "../assets/remitancenobg.png"

import worldimg from "../assets/world1.jpg"
import worldconnect from "../assets/worldconnect.png"

const coreMessage = () =>{
    return (
        <div>
            <section className="core">

            <div className='core-content'>
                <div className="core-left trust">
                    <img src={heroimage} alt="" />
                </div>

                <div className="core-right">
                    <h2>Trust & Reliability</h2>
                    <p>As Africa’s gateway to the global market, SureSend is built on trust. 
                        Our platform ensures secure, real-time transactions every time, 
                        so you can focus on what matters most—growing your business.
                    </p>
                </div>
                
            </div>

            <div className='market-content'>
                <div className="core-left market">
                    <h2>Empowering African Markets</h2>
                    <p>SureSend is dedicated to unlocking Africa's business potential 
                        by offering <br/>  a fast, secure, and affordable way to send and 
                        receive payments globally.<br/>Whether you're an entrepreneur
                        in Lagos or a small business in Nairobi, <br/>SureSend connects 
                        you to the world.
                    </p>
                </div>

                <div className="core-right">
                    <img src={worldconnect} alt="" />
                </div>
            </div>

            <div className='core-content'>
                <div className="core-left innovation">
                    <img src={worldimg} alt="" />
                </div>

                <div className="core-right">
                    <h2>Efficiency & Innovation at Your Fingertips</h2>
                    <p>SureSend, sending money or making payments across borders has 
                        never been easier. We offer seamless integration with the world’s 
                        financial systems, giving you the power to expand your business 
                        effortlessly, whether you're in Africa or anywhere else in the world.
                    </p>
                </div>
            </div>
            </section>
        </div>
    )
}

export default  coreMessage